const getSanitizedPropValues = values =>
  values.length ? values.reduce((prev, curr) => (curr.length ? [prev, ', ', curr] : prev)) : values;

export default getSanitizedPropValues;
